<template>
  <div :data-theme="appStore.theme">
    <Navbar />
    <MobileNav :is-open="mobileMenuOpen" @close="mobileMenuOpen = false" />
    <router-view />
  </div>
</template>

<script setup>
  import { ref, provide, onMounted, computed } from 'vue'
  import Navbar from './components/common/Navbar.vue'
  import MobileNav from './components/common/MobileNav.vue'
  import { useAppStore } from './store/modules/app'
  import { getApiConfig } from './config/api'
  import { useUserStore } from './store/modules/user'

  const appStore = useAppStore()
  const userStore = useUserStore()
  const mobileMenuOpen = ref(false)

  // 使用 computed 保持响应式
  provide(
    'theme',
    computed(() => appStore.theme)
  )
  provide('toggleTheme', () => appStore.toggleTheme())
  provide('mobileMenuOpen', mobileMenuOpen)
  provide('toggleMobileMenu', () => {
    mobileMenuOpen.value = !mobileMenuOpen.value
  })
  provide('loginUrl', getApiConfig().loginUrl)

  onMounted(async () => {
    // 初始化主题
    document.documentElement.setAttribute('data-theme', appStore.theme)

    // 检查 URL 参数中的 inviteCode
    const urlParams = new URLSearchParams(window.location.search)
    const inviteCode = urlParams.get('inviteCode')
    if (inviteCode) {
      try {
        await userStore.prepareLogin(inviteCode)
        // 清除 URL 中的 inviteCode 参数，避免重复调用
        urlParams.delete('inviteCode')
        const newUrl = urlParams.toString()
          ? `${window.location.pathname}?${urlParams.toString()}`
          : window.location.pathname
        window.history.replaceState({}, '', newUrl)
      } catch {
        // 邀请码存储失败，忽略继续
      }
    }

    // 获取用户信息
    try {
      await userStore.fetchProfile()
      // 用户信息获取成功后，尝试获取 API Key
      await userStore.fetchCurrentApikey()
    } catch {
      // 获取失败，用户未登录
    }
  })
</script>

<style>
  /* 确保主题应用到 html */
  html {
    background: var(--bg-primary);
  }
</style>
